<template lang="pug">
div.student-container
    div.content
        div.Practice.drill-Analysis
            div.drill-left
                h1.title 流程演练
                P.title-tag 已完成 {{testTotal}} 个流程实验
                p.tag-2
                //- 超过了30%的同学，继续加油哦！
                div.checkClick(@click='goprocess(1)') 查看报告&nbsp;>>
                //- button.frame(@click='goprocess(1)') 查看报告
            div.view
                img(src='../../assets/Student/home/policy.png')
            //- div.policy.drill-Analysis
            //-     div.drill-left
            //-         h1.title 政策分析
            //-         p.title-tag 已完成 0 个流程实验
            //-         P.tag-2
            //-         //- 超过了0%的同学，继续加油哦！
            //-         //- button.frame(@click='goprocess(2)') 查看排名
            //-         div.checkClick(@click="info") 查看报告&nbsp;>>
            //-         //- Button.frame(type="primary" @click="info") 查看报告
            //-     div.view-2
            //-         img(src='../../assets/Student/home/Bitmap@2x.png')
        div.usernews
            div.user-nav
                img.portrait(:src='userInfo.src')
                h1.username {{userInfo.name}}
                div
                  span.tag-3 政策分析师 |
                  span.tag-3  {{classcall}}
                img(src='../../assets/Student/home/medal.png').medal
                p.tag-4 作为一名政策分析师，参与政策制定、执行、评估和终结的全过程。
            div.news-nav
                div.column
                    span.column-Left 通知消息
                    span.column-right(@click='gonotice')
                      a 查看全部
                div.column-nav(style="width:326px;height:230px;" v-if='!subjectlist')
                  div.lavel-pic(style='margin-bottom:4px;')
                  span(style='margin:0 auto;color:#CCCCCC;margin-top:4px;display: inline-block;width: 100%;text-align:center;')  暂无数据
                div.column-nav(v-for='(x,idx) in subjectlist' v-else)
                    ul(v-if='idx<=2',@click='gonotice')
                      div(v-if='x.type==="教师分配实训通知"').type
                        div.content-tag
                          Badge(dot).notice
                          i.icon-msg.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont.column-title
                          span(style='font-size:14px;font-family:MicrosoftYaHeiUI;color:rgba(42,46,54,0.75);line-height:18px;position:relative;top: -5px;') 您有新的实训案例待完成
                          //- a 点击查看
                        p.time {{x.createdTime}}
                      div(v-if='x.type==="老师评分"').type
                        div.content-tag
                            Badge(dot).notice
                            i.icon-msg.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont.column-title
                            span.text(style='font-size:14px;font-family:MicrosoftYaHeiUI;color:rgba(42,46,54,0.75);line-height:18px;position:relative;top: -5px;') 您有新的实训报告可以下载
                            //- a 点击查看
                        p.time {{x.createdTime}}
                      div(v-if='x.type==="老师审核自定义案例"').type
                        div.content-tag
                            Badge(dot).notice
                            i.icon-msg.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont.column-title
                            span.text(style='font-size:14px;font-family:MicrosoftYaHeiUI;color:rgba(42,46,54,0.75);line-height:18px;position:relative;top: -5px;') 您提交的案例已经被审核
                        //-   a 点击查看
                        //- li.column-tag(v-html='`案例名称：<b>${JSON.parse(x.content).caseName} </b>`')
                        p.time {{x.createdTime}}
                      div(v-if='x.type==="密码重置提示"').type
                        div.content-tag
                          Badge(dot).notice
                            i.icon-msg.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont.column-title
                            span.text(style='font-size:14px;font-family:MicrosoftYaHeiUI;color:rgba(42,46,54,0.75);line-height:18px;position:relative;top: -5px;') 密码重置提示
                            //- a 点击查看
                        p.time {{x.createdTime}}
                      div(v-if='x.type==="教师延续分配通知"').type
                        div.content-tag
                          Badge(dot).notice
                          i.icon-msg.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont.column-title
                          span(style='font-size:14px;font-family:MicrosoftYaHeiUI;color:rgba(42,46,54,0.75);line-height:18px;position:relative;top: -5px;') 您有案例实训待完成
                          //- a 点击查看
                        p.time {{x.createdTime}}
        div.news-region
            div.tag-column
                span.tag-5 流程演练
                //- div.tag-6
                //-     i.icon-tubiaozhizuo-.iconfont.icon
                //- div.tag-7
                //-     i.icon-tubiaozhizuo-1.iconfont.icon
            div.label-area(v-if='list && list.length > 0')
              div.label-check(v-for='(v,idx) in list')
                div.lavel-frame(v-if='idx<=3',@click="gonovice(v)")
                    div.label-left
                        h1.label-title
                          span {{v.caseExperimentName}}
                          span.persent {{v.schedule}}%
                        p.label-tips {{v.caseDescription}}
                    div.label-right
                        div.label-time 截止:{{v.endTime}}
                        button.label-1(@click="gonovice(v)") {{v.schedule === 0 ? "开始实训" : "继续实训"}}
            div.label-area.label-null(v-else)
              div.label-check
                div.lavel-pic(style='margin-bottom:4px;')
                //- span(style='margin:0 auto;color:#CCCCCC;display: inline-block;width: 100%;text-align:center;')  暂无数据
                span.lavel-title.lavel-com() 当前无进行中的实验
                span.lavel-content.lavel-com() 可到流程演练中查看未开始和已结束的实验噢~


</template>

<script>
import MyBus from "@/utils/main";
export default {
  name: "home",
  data() {
    return {
      userInfo: {
        src: "",
        name: ""
      },
      list: [],
      subjectlist: [],
      classcall: "",
      testTotal: 0,
      willDoIndex: "",
      type: ["政策制定", "政策执行", "政策评估", "政策终结"],
      shortTime: 0
    };
  },
  methods: {
    // checkReaded(v) {
    //   const data = {
    //     ids: [v.id]
    //   };
    //   data.ids = JSON.stringify(data.ids);
    //   this.$http.updateNotificationRead(data).then(res => {
    //     console.log(res);
    //   });
    // },
    goprocess(index) {
      this.$router.push({
        path: "/Student/see_ranking",
        query: { id: index }
      });
    },
    gonovice(v) {
      sessionStorage.removeItem("stageId");
      window.location.href = `/policy_stu/?id=${v.caseExperimentId}&experimentId=${v.experimentId}`;
      // window.location.href = `http://localhost/policy_stu/?id=${v.caseExperimentId}&experimentId=${
      //   v.experimentId
      // }`;
      // return;
      // const data = {
      //   caseStep: "FORMULATE",
      //   pyId: v.caseExperimentId
      // };
      // if (v.beforeDistribution) {
      //   sessionStorage.beforeDistribution = this.type.indexOf(
      //     v.beforeDistribution
      //   );
      // } else {
      //   sessionStorage.beforeDistribution = -1;
      // }
      // // 通过点击将要执行的分配传进本地存储里
      // if (v.distribution === "政策制定") {
      //   this.willDoIndex = 1;
      // } else if (v.distribution === "政策执行") {
      //   this.willDoIndex = 2;
      // } else if (v.distribution === "政策评估") {
      //   this.willDoIndex = 3;
      // } else if (v.distribution === "政策终结") {
      //   this.willDoIndex = 4;
      // }
      // sessionStorage.setItem("willDoIndex", this.willDoIndex);
      // this.$http.getCasehallByPyIdAndCaseStep(data).then(res => {
      //   const data1 = {
      //     index: "FORMULATE",
      //     tsId: res.data.data.id,
      //     stageShow: res.data.data.stageShow
      //   };
      //   this.$store.commit("postStuCaseInformation", data1);
      //   const data3 = {
      //     caseExperimentId: v.caseExperimentId,
      //     experimentId: v.experimentId
      //   };
      //   sessionStorage.setItem("doIndex", -1);
      //   sessionStorage.setItem("initialState", 1);
      //   this.$store.commit("postStuCaseId", data3);
      //   if (v.finish) {
      //     this.$router.push({ path: "/doCase", query: { state: true } });
      //     return;
      //   }
      //   this.$router.push({ path: "/doCase", query: { state: false } });
      // });
    },
    gocustom() {
      this.$router.push("/Student/custom-case");
    },
    gonotice() {
      this.$router.push("/Student/notice_news");
    },
    /**
     * 查询用户
     * @param {{code: String}} params
     * @returns {Boolean}
     */
    async getByCode(params) {
      await this.$http
        .userInfo(params)
        .then(res => {
          if (!res.data.success) {
            return false;
          }
          // 登录成功
          this.userInfo.name = res.data.data.name;
          this.userInfo.src = res.data.data.headImagePath;
          return true;
        })
        .catch(() => {
          this.$Message.error("服务器异常");
        });
    },
    info() {
      this.$Message.info("敬请期待");
    },
    /**
     * 查询学生所在班级
     * @param {{userCode: string}} params
     * @returns {Boolean}
     */
    async querystudentclass(params) {
      await this.$http.querystudentclass(params).then(res => {
        if (!res.data.success) {
          console.log(res.data.message);
          return false;
        }
        this.classcall = res.data.data.className;
        return true;
      });
    },
    /**
     * 获取学生完成的实验总数
     * @param {{userId: string}} params
     * @returns {Boolean}
     */
    async ObtainExperimenttotal(params) {
      await this.$http.ObtainExperimenttotal(params).then(res => {
        if (!res.data.success) {
          console.log(res.data.message);
          return false;
        }
        this.testTotal = res.data.data;
        return true;
      });
    },
    /**
     * 查询外部通知
     * @param {String} userId
     * @returns {Boolean}
     */
    async listWithoutNotification(userId) {
      const params = {
        isRead: "0",
        pageNo: 1,
        pageSize: 20,
        types: JSON.stringify([
          "教师分配实训通知",
          "老师审核自定义案例",
          "老师评分",
          "教师延续分配通知"
        ])
      };
      params.userId = userId;
      await this.$http.listWithoutNotification(params).then(res => {
        if (!res.data.success) {
          console.log(res.data.message);
          return false;
        }
        try {
          this.subjectlist = res.data.data.list;
          if (this.subjectlist) {
            // 定义时间计算方式
            const Checkminute = 1000 * 60;
            const Checkhour = Checkminute * 60;
            const Checkday = Checkhour * 24;
            const Checkmonth = Checkday * 30;
            const nowTime = new Date().getTime();
            this.subjectlist.forEach(res1 => {
              // 转换时间戳算时间差
              res1.createdTime = new Date(res1.createdTime).getTime();
              this.shortTime = nowTime - res1.createdTime;
              if (this.shortTime / Checkmonth >= 1) {
                // eslint-disable-next-line radix
                res1.createdTime = `${parseInt(this.shortTime / Checkmonth)}月前`;
              } else if (this.shortTime / (7 * Checkday) >= 1) {
                // eslint-disable-next-line radix
                res1.createdTime = `${parseInt(this.shortTime / (7 * Checkday))}周前`;
              } else if (this.shortTime / Checkday >= 1) {
                // eslint-disable-next-line radix
                res1.createdTime = `${parseInt(this.shortTime / Checkday)}天前`;
              } else if (this.shortTime / Checkhour >= 1) {
                // eslint-disable-next-line radix
                res1.createdTime = `${parseInt(this.shortTime / Checkhour)}小时前`;
              } else if (this.shortTime / Checkminute >= 1) {
                // eslint-disable-next-line radix
                res1.createdTime = `${parseInt(this.shortTime / Checkminute)}分钟前`;
              } else {
                res1.createdTime = "刚刚";
              }
            });
          }
        } catch (err) {
          console.log(err);
          return false;
        }
        return true;
      });
    },
    /**
     * 查询实训进度
     * @param {{userId: string}} params
     * @returns {Boolean}
     */
    async querySchedule(params) {
      await this.$http.querytrainProgress(params).then(res => {
        if (res.data.success) {
          try {
            this.list = res.data.data.list;
            if (this.list) {
              this.list.forEach(tim => {
                tim.endTime = tim.endTime.match(/\d{2}-\d{2}\s\d{2}:\d{2}/)[0];
              });
            }
          } catch (err) {
            console.log(err);
            this.list = [];
          }
        }
      });
    }
  },
  async created() {
    const code = this.$role.code;
    await this.getByCode({ code });
    await this.querystudentclass({ userCode: code });
    await this.ObtainExperimenttotal({ userId: code });
    await this.querySchedule({ uesrId: code });
    await this.listWithoutNotification(code);
    this.$forceUpdate();
  },
  mounted() {
    MyBus.$on("msg", e => {
      this.userInfo.name = e.name;
      this.userInfo.src = e.headImagePath;
    });
  }
};
</script>

<style lang="stylus" scoped>
.student-container
  width 100%
  padding-bottom 120px
  .content
    display grid
    // grid-template-columns repeat(12, 1fr)
    grid-template-rows 200px 380px
    grid-template-areas 'm  c' 'f  c'
    width 1126px
    margin 0 auto
    margin-top 48px
    column-gap 20px
    row-gap 20px
    text-align left
    .drill-Analysis
      padding 32px 24px
      display grid
      grid-template-columns 70% 30%
      .drill-left
        .title
          font-size 20px
          font-family MicrosoftYaHeiUI-Bold
          font-weight bold
          color rgba(74, 144, 226, 1)
        .title-tag
          font-size 14px
          font-family MicrosoftYaHeiUI
          color rgba(42, 46, 54, 0.75)
          margin-top 24px
          // .tag-2
          //   font-size 14px
          //   font-family MicrosoftYaHeiUI
          //   color rgba(128, 128, 128, 0.5)
          //   margin-top 4px
          //   height 50px
          // .frame
          //   width 86px
          //   height 32px
          //   background rgba(60, 118, 208, 0.1)
          //   border-radius 4px
          //   border none
          //   outline none
          //   font-size 14px
          //   font-family MicrosoftYaHeiUI
          //   color rgba(58, 118, 210, 1)
          //   margin-top 18px
          //   cursor pointer
          //   &:hover
          //     color #FFFFFF
          //     background #4485F0
        .checkClick
          color #3A76D2
          cursor pointer
          margin-top 50px
      .view
        img
          width 220px
          height 147px
      .view-2
        img
          width 73px
          margin-top 53px
          position relative
          left 12px
    .Practice
      grid-area m
      background #FFFFFF
      box-shadow 0px 2px 6px 0px rgba(0, 0, 0, 0.04)
      border-radius 4px
    .policy
      grid-area h
      background #FFFFFF
      box-shadow 0px 2px 6px 0px rgba(0, 0, 0, 0.04)
      border-radius 4px
    .usernews
      grid-area c
      box-shadow 0px 2px 6px 0px rgba(0, 0, 0, 0.04)
      border-radius 4px
      text-align center
      display grid
      grid-template-columns 100%
      margin-top -4px
      .user-nav
        background url('../../assets/Student/home/texture.png')
        background-repeat no-repeat
        background-position-x -7px
        height 308px
        .portrait
          width 88px
          height 88px
          background #eef7fe
          border-radius 50%
          border 1px solid #3C76D0
          margin 36px auto
          margin-bottom 12px
        .username
          font-size 16px
          font-family MicrosoftYaHeiUI-Bold
          font-weight bold
          color rgba(42, 46, 54, 0.8)
        .tag-3
          font-size 12px
          font-family MicrosoftYaHeiUI
          color rgba(42, 46, 54, 0.8)
          margin-top 4px
        .medal-p
          font-size 14px
          font-family MicrosoftYaHeiUI-Bold
          font-weight bold
          color rgba(245, 166, 35, 1)
          margin-top 4px
          display inline-block
        .medal
          width 26px
          position relative
          top 7px
        .tag-4
          font-size 12px
          font-family MicrosoftYaHeiUI
          color rgba(128, 128, 128, 0.5)
          margin-top 12px
          padding 0 48px
    .news-nav
      background #FFFFFF
      height 290px
      .column
        height 60px
        background rgba(255, 255, 255, 0.91)
        box-shadow 0px -1px 0px 0px rgba(0, 0, 0, 0.08)
        border-radius 4px 4px 0px 0px
        border-bottom 1px solid #eee
        .column-Left
          float left
          font-size 14px
          font-family MicrosoftYaHeiUI-Bold
          font-weight bold
          line-height 60px
          padding-left 24px
        .column-right
          float right
          padding-right 23px
          a
            font-size 12px
            font-family MicrosoftYaHeiUI
            color #307CF1
            line-height 60px
            cursor pointer
      .column-nav
        text-align left
        .lavel-pic
          width 120px
          height 124px
          background-image url('../../assets/Student/home/nothing.png')
          background-repeat no-repeat
          background-position center
          margin-top 40px
          margin-left 104px
        .type
          cursor pointer
      .content-text
        margin 15px 0 0 62px
        a
          margin-left 8px
      .content-tag
        margin-top 16px
        .notice
          top -12px
          left 50px
          .ivu-badge-dot
            left 0
        .column-title
          // background url('../../assets/Student/home/icon.png')
          // background-repeat no-repeat
          margin 10px 24px -44px 26px
          // padding-left 38px
          margin-left 24px
          font-size 24px
          color #508FF4
          display inline-block
          line-height 24px
          position relative
          top 5px
        .text
          font-size 14px
          position relative
          top -10px
        // a
        //   margin-left 8px
      .column-tag
        // height 24px
        // background url('../../assets/Student/home/icon.png')
        background-repeat no-repeat
        height 67px
        margin 0 0 -44px 24px
        // background-position-y 8px
        // padding-left 38px
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 0.75)
      .time
        font-size 12px
        font-family MicrosoftYaHeiUI
        color rgba(128, 128, 128, 0.5)
        text-align left
        margin-left 70px
    .news-region
      grid-area f
      background #FFFFFF
      box-shadow 0px 2px 6px 0px rgba(0, 0, 0, 0.04)
      border-radius 4px
      .tag-column
        width 780px
        height 60px
        border-bottom 1px solid #eee
        .tag-5
          font-size 14px
          font-family MicrosoftYaHeiUI-Bold
          font-weight bold
          color rgba(42, 46, 54, 0.8)
          line-height 60px
          padding-left 24px
        .tag-6
          width 24px
          height 24px
          background #F0F2FF
          border-radius 4px
          float right
          text-align center
          margin 18px 27px 18px 8px
        .tag-7
          width 24px
          height 24px
          background #F0F2FF
          border-radius 4px
          float right
          text-align center
          margin-top 18px
        .iconfont
          color #9AA4D3
      .label-area
        width 780px
        .label-check
          width 100%
          height 100%
          .lavel-frame
            height 44px
            margin 25px 24px 0
            cursor pointer
            .label-left
              display inline-block
              max-width 410px
              .label-title
                font-size 14px
                font-family MicrosoftYaHeiUI
                color #2A2E36
                display -webkit-box
                -webkit-box-orient vertical
                -webkit-line-clamp 1
                overflow hidden
                font-weight normal
                .persent
                  width 55px
                  display inline-block
                  background rgba(253,96,149,0.2)
                  border-radius 9px
                  font-size 12px
                  font-weight 600
                  color rgba(253,96,149,1)
                  line-height 21px
                  text-align center
                  margin-left 19px
              .label-tips
                font-size 12px
                font-family MicrosoftYaHeiUI
                color rgba(128, 128, 128, 0.5)
                display -webkit-box
                -webkit-box-orient vertical
                -webkit-line-clamp 1
                overflow hidden
            .label-right
              float right
              display flex
              .label-1
                width 86px
                height 32px
                background rgba(60, 118, 208, 0.1)
                border-radius 4px
                border none
                outline none
                font-size 14px
                font-family MicrosoftYaHeiUI
                color rgba(58, 118, 210, 1)
                margin-top 6px
                cursor pointer
                &:hover
                  color #FFFFFF
                  background #4485F0
              .label-time
                font-size 12px
                color #AFB1B7
                margin-right 24px
                line-height 44px
          .lavel-pic
            width 120px
            height 124px
            background url('../../assets/Student/home/nothing.png')
            background-repeat no-repeat
            background-position center
            margin-top 42px
            margin-left 330px
      .label-null
        .lavel-com
          display: inline-block;
          width: 100%;
          text-align: center;
        .lavel-title
          margin: 20px auto 0;
          color: rgba(42, 46, 54, 0.8);
          font-size: 20px;
          font-weight: 600;
        .lavel-content
          margin:12px auto 0;
          color:rgb(202,199,203);
</style>
